// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1YSts","title":"Images90_title__1GgW_","images":"Images90_images__1u_ke"};